import "vite/modulepreload-polyfill";
import "../fonts-loader";
import "../css-url-rewriter";
import "../scss/style.scss";
import initialiseNav from "./components/navigation";

initialiseNav();

if (document.getElementById("alert-message")) {
  import("./components/alert").then((init) => init.default());
}

if (document.querySelector(".js-add-more")) {
  import("./components/addMore").then((init) => init.default());
}

if (document.querySelector(".js-autocomplete")) {
  import("./components/autocomplete").then((init) => init.default());
}

if (document.querySelector(".js-lightbox")) {
  import("./components/lightbox").then((init) => init.default());
}

if (document.querySelector(".js-isotope-grid")) {
  import("./components/isotope").then((init) => init.default());
}

if (document.querySelector(".js-masonry-grid")) {
  import("./components/masonry").then((init) => init.default());
}

if (document.querySelector(".js-search-elsewhere")) {
  import("./components/search").then((init) => init.default());
}

if (document.querySelector("[data-map-type='single']")) {
  import("./components/singleMap").then((init) => init.default());
}
